<ng-container *ngIf="!isFWAErrorResp; else showErrorMessage">
    <nz-spin [nzSpinning]="isLoadingFWAData" [nzTip]="FWADataLoadingMsg">
    
        <!------------Fraud-o-meter and other cards ------------->
        <div class="fwa-summary-section">
    
            <div class="fwa-summary-block">
                <h5><em nz-icon nzType="dashboard" nzTheme="outline"></em> {{'Fraud-O-Meter' | MMSTranslate}}</h5>
    
                <div class="fwa-summary-block-grid">
                    <div *ngIf="fraudScore" class="fraud-o-meter-chart-sec"
                        [ngStyle]="{'background-color': getFraudOMeterColor(fraudScore)}">
                        <apx-chart [series]="fraudOMeterChart.series" [chart]="fraudOMeterChart.chart"
                            [labels]="fraudOMeterChart.labels" [plotOptions]="fraudOMeterChart.plotOptions"
                            [colors]="fraudOMeterChart.colors">
                        </apx-chart>
                        <div class="fraud-o-meter-risk-label">{{ fraudRisk }} </div>
                        <!-- <div class="h-100-pc">
                        <ngx-gauge size="125" type="semi" min="0" max="100" [value]="fraudScore" cap="round" thick="10"
                            label="Risk" append="/100" backgroundColor="rgba(0,0,0,0.4)" [thresholds]="gaugeThresHold">
                        </ngx-gauge>
                    </div> -->
                    </div>
                    <div class="p-20">
                        <!-- <h5><em nz-icon nzType="safety"></em> {{'Recommended action' | MMSTranslate}}</h5> -->
                        <ul class="f-w-600" [ngSwitch]="fraudRisk">
                            <li class="color-danger" *ngSwitchCase="'High Risk'">An investigation may be warranted.</li>
                            <li class="color-warning" *ngSwitchCase="'Medium Risk'">The Underwriter is advised to thoroughly
                                analyze the case and determine the necessity of an investigation.</li>
                            <li class="color-safe" *ngSwitchCase="'Low Risk'">Recommended for Standard Underwriting.</li>
                            <!-- <li class="color-warning" *ngSwitchDefault>We are unable to calculate the risk at this moment,
                                please try again after sometime.</li> -->
                        </ul>
                        <p class="col-grey-light">
                            * {{'System recommended action is based on heuristic data and AI/ML data models' |
                            MMSTranslate}}
                        </p>
                        <div *ngIf="fraudRisk != 'Low Risk' && overallInvestigationRecommendation">
                            <nz-divider nzText="Overall Investigation Recommendation"></nz-divider>
                            <p>
                                {{overallInvestigationRecommendation}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="fraud-o-meter-disclaimer-sec">
                    <nz-alert [nzType]="isFWADataMissing ? 'warning' : 'info'" [nzMessage]="mlInfoMessageTpl"></nz-alert>
                    <ng-template #mlInfoMessageTpl>
                        <div class="fraud-o-meter-disclaimer-data">
                            <div class="col-grey-light">
                                <ng-container *ngIf="isFWADataMissing; else showFWAInfoMsg">
                                    <span class="f-w-600">Caution: </span>
                                    <span class="fraud-o-meter-disclaimer-text">The absence of all critical information required to generate a Fraud Score may have resulted into a slight inaccuracy in the score.</span>
                                </ng-container>
                                <ng-template #showFWAInfoMsg>
                                    <span class="f-w-600">Note: </span>
                                    <span class="fraud-o-meter-disclaimer-text">{{'The fraud risk is calculated based on various factors like Location of Proposal, Whether Agent/Partner is Blacklisted, Age of Insured Persons, Medical History, Occupation & Income of Member' | MMSTranslate}}</span>
                                </ng-template>
                            </div>
                            <div class="ML-modal-tag">
                                <nz-tag [nzColor]="'#108ee9'">
                                    <img src="/assets/images/ico/brainIcon.png">
                                    <span style="font-size: 11px;margin-left: 5px;">Based on ML model</span>
                                </nz-tag>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
    
            <div class="fwa-summary-block">
                <h5><em nz-icon nzType="radar-chart" nzTheme="outline"></em> {{'Involvement metrics' | MMSTranslate}}</h5>
                <apx-chart [series]="involvementMetricsChart.series" [chart]="involvementMetricsChart.chart" [xaxis]="involvementMetricsChart.xaxis"
                    [colors]="involvementMetricsChart.colors" [dataLabels]="involvementMetricsChart.dataLabels"
                    [tooltip]="involvementMetricsChart.tooltip" [plotOptions]="involvementMetricsChart.plotOptions" [markers]="involvementMetricsChart.markers"
                    [title]="involvementMetricsChart.title"></apx-chart>
            
                <!-- <canvas class="chart" baseChart [data]="involvementMetricsChartData"
                            [labels]="involvementMetricsChartLabels" [options]="involvementMetricsChartOptions"
                            [type]="involvementMetricsChartType">
                        </canvas> -->
            
            </div>
    
        </div>
    
        <!------------Peculiar patterns and fraudulent patterns ------------->
        <nz-spin [nzSpinning]="isLoadingFWAPattern">
            <nz-collapse class="patterns-data-collapse-sec">
                <nz-collapse-panel [nzHeader]="tmplFraudPatternTitle" [nzActive]="true">
                    <ng-template #tmplFraudPatternTitle>{{'Self-learned Fraud Rules by the System' |
                        MMSTranslate}}</ng-template>
                    <div
                        *ngIf="!isFWAPatternErrorResp && fraudulentPatterns && fraudulentPatterns.length > 0; else displayEmptyListForFraudPattern">
                        <div>
                            <nz-list nzItemLayout="horizontal">
                                <nz-list-item *ngFor="let f_pattern of fraudulentPatterns; let i = index;">
                                    <nz-list-item-meta nzAvatar="/assets/images/ico/fraud.png" [nzDescription]="f_pattern">
                                        <nz-list-item-meta-title>
        
                                        </nz-list-item-meta-title>
                                    </nz-list-item-meta>
                                </nz-list-item>
                            </nz-list>
                        </div>
                        <div>
                        </div>
                    </div>
                </nz-collapse-panel>
                <nz-collapse-panel [nzHeader]="tmplPeculiarPatternsTitle" [nzActive]="true">
                    <ng-template #tmplPeculiarPatternsTitle>{{'Peculiar patterns considered during prediction' |
                        MMSTranslate}}</ng-template>
                    <div class="peculiarPatterns-sec"
                        *ngIf="!isFWAPatternErrorResp && peculiarPatterns && peculiarPatterns.length > 0; else displayEmptyListForPeculiarPattern">
                        <div>
                            <!-- <canvas baseChart class="chart" [data]="peculiarPatternData" [options]="peculiarPatternChartOptions"
                                                [type]="peculiarPatternChartType">
                                            </canvas> -->
                            <apx-chart [series]="peculiarPatternChart.series" [chart]="peculiarPatternChart.chart"
                                [dataLabels]="peculiarPatternChart.dataLabels" [plotOptions]="peculiarPatternChart.plotOptions"
                                [xaxis]="peculiarPatternChart.xaxis"></apx-chart>
                        </div>
                        <div class="peculiarPatterns-list-sec">
                            <nz-list nzItemLayout="horizontal">
                                <nz-list-item *ngFor="let p_pattern of peculiarPatterns; let i = index;">
                                    <nz-list-item-meta [nzTitle]="pPatternTitle"
                                        nzAvatar="/assets/images/ico/{{p_pattern['impactWeight'] > 0 ? 'up' : p_pattern['impactWeight'] < 0 ? 'down' : 'neutral'}}-arrow.png"
                                        [nzDescription]="pPatternDesc">
                                        <ng-template #pPatternTitle>
                                            <!-- <span>
                                                {{p_pattern['impactWeight'] > 0 ? "Positive" : p_pattern['impactWeight'] < 0
                                                ? "Negative" : "No" }} impact on Fraud Propensity<span
                                                *ngIf="p_pattern['impactWeight']">:
                                                {{(getAbsoluteValue(p_pattern['impactWeight']) * 100).toFixed(2)}}%</span>
                                            </span> -->
                                            <span>
                                                {{'Pattern #' + (i+1) + ': '}} {{p_pattern['rule']}}; Pattern Importance:
                                                {{(p_pattern['impactWeight'] * 100).toFixed(2)}}%
                                            </span>
                                            <!-- <span *ngIf="p_pattern['inputDataValue']">
                                                | Value : {{p_pattern['inputDataValue']}} 
                                            </span>     -->
                                        </ng-template>
                                        <ng-template #pPatternDesc>
                                            <ul>
                                                <li><span class="f-w-600">Description: </span> {{p_pattern['summary']}}</li>
                                                <!-- <li *ngIf="p_pattern['rule']"><span class="f-w-600">Rule: </span>{{p_pattern['rule']}}</li> -->
                                                <li
                                                    *ngIf="p_pattern['recommendedIinvestigation'] && p_pattern['impactWeight'] > 0 && fraudRisk != 'Low Risk'">
                                                    <span class="f-w-600">Investigation recommendation:
                                                    </span>{{p_pattern['recommendedIinvestigation']}}
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </nz-list-item-meta>
                                </nz-list-item>
                            </nz-list>
                        </div>
                    </div>
                </nz-collapse-panel>
        
                <ng-template #displayEmptyListForFraudPattern>
                    <nz-result *ngIf="!isLoadingFWAPattern" [nzIcon]="'smile-twotone'"
                        [nzTitle]="'Great, No self-learned rules triggered for this case!!'"></nz-result>
                </ng-template>
        
                <ng-template #displayEmptyListForPeculiarPattern>
                    <nz-empty></nz-empty>
                </ng-template>
        
            </nz-collapse>
        </nz-spin>
    
        <!------------Fraud Rules ------------->
        <nz-collapse nzGhost>
            <nz-collapse-panel [nzHeader]="fwaRulesTitleTpl" [nzActive]="false" class="m-t-20">
    
                <ng-template #fwaRulesTitleTpl>
                    <h3 class="collapsible-tpl-heading"><em nz-icon nzType="control" nzTheme="outline"></em> {{'Fraud Rules'
                        |
                        MMSTranslate}}</h3>
                </ng-template>
                <app-data-list *ngIf="fwaRules && fwaRules.length > 0" [listOfData]="fwaRules" filterBasedOn="decision"
                    [title]="'Rules'" [listFor]="'FWA_RULES'"></app-data-list>
    
            </nz-collapse-panel>
        </nz-collapse>
    
        <!------------Decision Form ------------->
        <nz-collapse nzGhost>
            <nz-collapse-panel [nzHeader]="fwaDecisionTitleTpl" [nzActive]="true" class="m-t-20">
    
                <ng-template #fwaDecisionTitleTpl>
                    <h3 class="collapsible-tpl-heading"><em nz-icon nzType="file-done" nzTheme="outline"></em> {{
                        'FWA Decision' | MMSTranslate}}</h3>
                </ng-template>
    
                <div class="isFraud-sec">
                    <label nz-checkbox [(ngModel)]="isFraud">
                        <span class="f-s-16p">{{ 'Mark this checkbox in the event that the case is identified as an instance of Fraud, Abuse, or Waste.' | translate}}</span>
                    </label>
                </div>
    
                <ng-container *ngIf="isFraud">
                    <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]" FORMTITLE=""
                        FORMNAME="FWADecisionForm" [IO]="_IO" [currentComponentName]="_currentComponentName"
                        (componentOutput)="_BaseEmitHandler($event)"
                        [formMetaData]="configData.ComponentMetaDataConfiguration.FWADecisionComponent">
                    </app-dynamic-form>
                </ng-container>
    
            </nz-collapse-panel>
        </nz-collapse>
    
    </nz-spin>
    </ng-container>
    <ng-template #showErrorMessage>
        <nz-result nzStatus="500" nzTitle="Unable to process request" [nzSubTitle]="FWAErrorMsg"></nz-result>
    </ng-template>